import { useLocation } from 'react-router-dom';
import Header from './components/layout/header';
import Footer from './components/layout/footer';
import MainContent from './components/layout/mainContent';
import { DataProvider } from './Provider/dataProvider';
import './css/account.css';

function App() {
  const location = useLocation();
  const isAuthRoute = location.pathname === '/login' || location.pathname === '/register' || location.pathname === '/forgot-password' || location.pathname === '/reset-password';

  return (
    <DataProvider>
      {!isAuthRoute && <Header />}
      <MainContent />
      {!isAuthRoute && <Footer />}
    </DataProvider>
  );
}

export default App;
